/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-extra-boolean-cast */
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class IpbSessionStorageService {
	private storage: Storage;

	public constructor() {
		this.storage = window.sessionStorage;
	}

	public set(key: string, value: string): boolean {
		if (!!this.storage) {
			this.storage.setItem(key, JSON.stringify(value))
			return true
		}
		return false
	}

	public get(key: string): any {
		if (!!this.storage) {
			return JSON.parse(this.storage.getItem(key) as string)
		}
		return null
	}

	public remove(key: string): boolean {
		if (!!this.storage) {
			this.storage.removeItem(key)
			return true
		}
		return false
	}

	public clear(): boolean {
		if (!!this.storage) {
			this.storage.clear()
			return true
		}
		return false
	}
}
